import React from 'react';
import { bonuses } from '../data/bonuses';
import { OFFER_ANCHOR } from './constants';
export function BonusSection() {
  return <section className="bg-white px-3 py-3 sm:px-4 sm:py-4" data-id="element-39" data-mp="1ofc5fttsurgy">
      <div className="mx-auto max-w-4xl" data-id="element-40" data-mp="22g532nfee2oa">
        <h2 className="mb-1.5 text-center font-display text-xl font-extrabold uppercase leading-tight tracking-tight sm:text-4xl" data-id="element-41" data-mp="22f3gblp0rrqq">
          🎁 5 Premium Bonuses Included
        </h2>
        <div className="grid gap-1.5 sm:grid-cols-2 sm:gap-2" data-id="element-42" data-mp="1ap8onidovpyw">
          {bonuses.map(bonus => <a key={bonus.num} href={OFFER_ANCHOR} className="flex flex-col rounded-lg border border-pf-gold/70 bg-pf-cream p-2.5 shadow-sm transition-colors duration-150 ease-out hover:border-pf-navy sm:p-3" data-id="element-43" data-mp="15qnm3caysu7a">
              <h3 className="font-display text-[13px] font-extrabold uppercase leading-tight text-pf-navy sm:text-base" data-id="element-44" data-mp="qzy9c5huv71b">
                🎁 Bonus {bonus.num} — {bonus.title}
              </h3>
              {bonus.lines.map(line => <p key={line} className="mt-0.5 text-[12px] font-medium leading-snug text-pf-ink sm:text-sm" data-id="element-45" data-mp="29rjvgswcslbx">
                  {line}
                </p>)}
              <p className="mt-0.5 text-[12px] font-bold leading-snug text-pf-coral sm:text-sm" data-id="element-46" data-mp="2jjzapig9mvt4">
                {bonus.close}
              </p>
            </a>)}
        </div>
      </div>
    </section>;
}